
import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    JOURNEY,
    GET_JOURNEY,
    GET_JOURNEY_TRAVELLED,
    GET_JOURNEY_TRAVELLED_BY_FILTER
} from "./type";
import {fireEvent} from "../../component/MoEngage";



export const save = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.journeySave}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: JOURNEY,
            payload: data.response,
        });
        return true;
    }
};

export const getJourney = (moduleType) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getJourney}?module_type=${moduleType}`
    );
    fireEvent('debugging_event', {
        type: 'api_call',
        api_endpoint: `${Config.getJourney}?module_type=${moduleType}`,
        step: "api_request_start",
        page: window?.location?.pathname,
    });
    if (res) {
        const { data } = res;
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.getJourney}?module_type=${moduleType}`,
            step: "api_request_success",
            page: window?.location?.pathname,
        });
        dispatch({
            type: GET_JOURNEY,
            payload: data.response,
        });
        return true;
    } else {
        fireEvent('debugging_event', {
            type: 'api_call',
            api_endpoint: `${Config.getJourney}?module_type=${moduleType}`,
            step: "api_request_fail",
            page: window?.location?.pathname,
        });
    }
};

export const getJourneyTravelled = (page=1, module_type, assigned_to = '', from_date = new Date().toJSON().slice(0, 8)+"01", to_date = '') => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getJourneyTravelled}?module_type=${module_type}&page=${page}&assigned_to=${assigned_to}&from_date=${from_date}&to_date=${to_date}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_JOURNEY_TRAVELLED,
            payload: data.response.data,
        });
        return true;
    }
};

export const getJourneyTravelledByFilter = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        Config.getJourneyTravelledByFilter
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_JOURNEY_TRAVELLED_BY_FILTER,
            payload: data.response,
        });
        return true;
    }
};